export default __webpack_public_path__ + "static/media/loader.5755a5b5.gif";